module.exports = __webpack_public_path__ + "images/money-28cfcd8e.svg";